import React, { Component } from 'react';
import PropTypes from 'prop-types';

class EmailRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { value } = this.props;
    if (value) {
      return (
        <div>
          <a
            href={`mailto:${value}`}
          >
            {value}
          </a>
        </div>
      );
    }
    return <div>{value}</div>;
  }
}

EmailRenderer.propTypes = {
  value: PropTypes.string,
};
EmailRenderer.defaultProps = {
  value: null,
};

export default EmailRenderer;
